module.exports = __webpack_public_path__ + "static/media/toggle_off.493593c5.svg";